import { BackgroundColors } from '@picsart/design-system/foundation/colors';

import { Easing } from '@picsart/design-system/foundation/easing';
import { Timings } from '@picsart/design-system/foundation/timings';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles<string, { height?: string | number }>(
  () => ({
    '@keyframes skeletonAnimation': {
      '0%': {
        backgroundPosition: '0 0',
      },
      '100%': {
        backgroundPosition: '300% 0',
      },
    },
    root: {
      display: 'block',
      width: '100%',
      height: '100%',
      backgroundColor: BackgroundColors.tint2,
      backgroundImage: `linear-gradient(45deg, ${BackgroundColors.tint2}, ${BackgroundColors.tint3}, ${BackgroundColors.tint2})`,
      backgroundRepeat: 'no-repeat',
      backgroundAttachment: 'scroll',
      backgroundSize: '300% 100%',
      backgroundPosition: '0 0',
      animationName: '$skeletonAnimation',
      animationTimingFunction: Easing.easeInOut,
      animationIterationCount: 'infinite',
      animationDuration: Timings.long,
      transform: 'translate3d(0, 0, 0)',
      overflow: 'hidden',
    },
  }),
  {
    name: 'skeleton',
  },
);

export default useStyles;
